module.exports = __webpack_public_path__ + "img/chevron-left-white.9465f240.svg";